import { chairsNum } from "@/utils/constants";

import "./ScheduleChairString.scss";

export default function ScheduleChairString() {
    return (
        <ul className='chair_listing'>
            {Array.from({ length: chairsNum }, (_, index) => (
                <li key={index} className='chair_item'>
                    <div className='chair_item_img_container' />
                    <p>Крісло {index + 1}</p>
                </li>
            ))}
        </ul>
    );
}
